
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FirstPageInfoItem, group, groupUser } from '@/interfaces/websocketMessageInterfaces';
import moment from 'moment';
import i18n from '@/lang';
import { SwipeCell } from 'vant';
import { deleteSession } from '@/apis/Instantmessaging';

@Component
export default class MessageListItem extends Vue {
  @Prop() messageData!: FirstPageInfoItem;
  private moment = moment;
  private showMessage = '';

  constructor() {
    super();
  }
  mounted() {
    if (this.messageData.lastMsg && this.messageData.lastMsg.msgType !== 0) {
      switch (this.messageData.lastMsg.msgType) {
        case 1:
          this.showMessage = '[图片]';
          break;
        case 2:
          this.showMessage = '[文件]';
          break;
        case 3:
          this.showMessage = '[音频]';
          break;
        case 4:
          this.showMessage = '[视频]';
          break;
        case 10:
          // @ts-ignore
          this.showMessage = JSON.parse(this.messageData.lastMsg.msgContent).title;
          break;
        default:
          this.showMessage = '';
          return;
      }
    } else {
      this.showMessage = this.messageData.lastMsg ? this.messageData.lastMsg.msgContent : '';
    }
  }

  goToChat() {
    this.$router.push({
      path: '/chat',
      query: {
        groupId: this.messageData.group.id,
        friendid:this.messageData.systemUid,
        coursename: this.messageData.group.remark
      }
    });
  }

  onClose(){

  }

  /**
   * 删除
   */
  deleteItem(groupid:string){
    deleteSession({groupid:groupid}).then((res:any)=>{
      this.$emit('deleteItemSucc',groupid);
      this.$toast.success('删除成功');
    });
  }

}
